// extracted by mini-css-extract-plugin
export default {"card":"Card_card__dIA1M","cardTextContainer":"Card_cardTextContainer__ZNZEU"};